import '@babel/polyfill';
import * as React from 'react';
import AppLoader from '../../components/AppLoader';
import AuthRequestQuote from './AuthRequestQuote';
import { withLoadingContext } from '../../components/AppLoader/Loading';
import {
  IContractStatus,
  ICustomerCode,
  IDivisionCode,
  ISharedAppContext,
  SharedAppConsumer,
  SharedAppProvider
} from '@origin-digital/shared-app-context';

const LoadingAwareAuthRequestQuoteApp = withLoadingContext(AuthRequestQuote);

const temp = {
  premiseId: '2000105870',
  contractAccountId: '500003528527',
  businessPartnerId: '383279',
  customerCode: ICustomerCode.RESI,
  properties: [
    {
      premiseId: '2000105870',
      addressId: '1546518',
      premiseName: '26 BONYTHON WAY, CRAIGBURN FARM SA 5051',
      premisePrimary: true,
      contractAccounts: [
        {
          contractAccountId: '500003528527',
          divisionCode: IDivisionCode.ELECTRICITY,
          status: IContractStatus.ACTIVE
        },
        {
          contractAccountId: '500003528535',
          divisionCode: IDivisionCode.NATURAL_GAS,
          status: IContractStatus.ACTIVE
        }
      ]
    },
    {
      premiseId: '2001162338',
      addressId: '30726169',
      premiseName: '12 CRESCENT AVE, ENOGGERA QLD 4051',
      premisePrimary: false,
      contractAccounts: [
        {
          contractAccountId: '400029209063',
          divisionCode: IDivisionCode.ELECTRICITY,
          status: IContractStatus.ACTIVE
        },
        {
          contractAccountId: '400029209071',
          divisionCode: IDivisionCode.NATURAL_GAS,
          status: IContractStatus.ACTIVE
        }
      ]
    }
  ]
};

const App = () => (
  <SharedAppProvider stateFromConfig={temp}>
    <AppConsumer />
  </SharedAppProvider>
);

const AppConsumer = () => (
  <SharedAppConsumer>
    {(context: ISharedAppContext) => {
      let primaryAddress = undefined;
      if (context.premiseId) {
        const selectedPremise = context.properties.find(
          property => property.premiseId === context.premiseId
        );
        if (selectedPremise) {
          primaryAddress = selectedPremise.premiseName;
        }
      }
      return <AppLoader app={LoadingAwareAuthRequestQuoteApp} primaryAddress={primaryAddress} />;
    }}
  </SharedAppConsumer>
);

export default App;
